export default "__VITE_ASSET__CLqbsVzS__"